import "./styles/SocialIcons.css";
import { useMemo } from "react";
import { useContentfulLiveUpdates, useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useSiteData } from "../../context/SiteDataContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface SocialIcon {
    title: string;
    url: string;
    icon: {
        url: string;
    };
    sys?: {
        id: string;
    };
}

const SocialIcons = () => {
    const { data, isLoading } = useSiteData();
    const inspectorProps = useContentfulInspectorMode();

    const iconsData = data?.socialMediaIconsCollection?.items || [];
    const rawSocialIcons: SocialIcon[] = iconsData[0]?.iconsCollection?.items || [];
    // Contentful returns null for unresolved/unpublished linked entries in a collection.
    const socialIcons = useContentfulLiveUpdates(rawSocialIcons).filter(Boolean);

    const socialSkeletonLoader = useMemo(() => [
        { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }
    ], []);

    return (
        <div className="social-icons-container">
            <div className="social-icons"
                style={{ display: isLoading ? 'flex' : 'none' }}
            >
                {socialSkeletonLoader.map((item) => (
                    <Skeleton
                        key={`skeleton-${item.id}`}
                        circle
                        width={38}
                        height={38}
                        baseColor="var(--color-surface-2)"
                        highlightColor="var(--color-border-strong)"
                    />
                ))}
            </div>

            <div className="social-icons"
                style={{ display: isLoading ? 'none' : 'flex' }}
            >
                {socialIcons.filter((icon) => icon?.icon?.url).map((icon, index) => (
                    <a
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                        href={icon.url}
                        title={`Open ${icon.title} in a new tab`}
                        {...inspectorProps({
                            entryId: icon.sys?.id || '',
                            fieldId: 'url',
                        })}
                    >
                        <img
                            src={icon.icon.url + "?w=36&h=36&fm=webp&fit=fill"}
                            alt={icon.title}
                            title={`${icon.title} icon`}
                            width={36}
                            height={36}
                            loading="lazy"
                            crossOrigin="anonymous"
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default SocialIcons;
